import { render, staticRenderFns } from "./guanyuanPage.vue?vue&type=template&id=00a90aba&scoped=true&"
import script from "./guanyuanPage.vue?vue&type=script&lang=js&"
export * from "./guanyuanPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a90aba",
  null
  
)

export default component.exports